export const getPnm = state => state.get('pnm');

export const getCurrentUser = state => state.get('currentUser');
